import { Component, computed, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'cipo-smart-banner',
  imports: [FlexLayoutModule, TranslateModule, MatButtonModule, MatIconModule],
  templateUrl: './smart-banner.component.html',
  styleUrl: './smart-banner.component.scss',
  host: { '[class.visible]': 'visible()' },
})
export class SmartBannerComponent {
  private readonly dismissed = signal(!!sessionStorage.getItem('appBannerDismissed'));
  private readonly testBanner = !!localStorage.getItem('appBannerTest');

  /** True on iOS and Android devices while not dismissed. */
  protected readonly visible = computed(() => {
    const ua = navigator.userAgent.toLowerCase();
    const isMobile = /android|iphone|ipad|ipod/.test(ua);
    return (this.testBanner || isMobile) && !this.dismissed();
  });

  /** Open the deep link directly with an optional browser-test store fallback. */
  openApp(): void {
    const useStoreFallback = !!localStorage.getItem('appBannerBrowserTest');

    if (useStoreFallback) {
      const isAndroid = /android/i.test(navigator.userAgent);
      window.open(isAndroid ? environment.playStoreUrl : environment.appStoreUrl, '_blank');
      return;
    }

    // A hard navigation is required for Universal Links/App Links to be intercepted by the OS.
    window.location.href = window.location.href;
  }

  /** Dismiss the banner for the remainder of the session. */
  dismiss(): void {
    sessionStorage.setItem('appBannerDismissed', '1');
    this.dismissed.set(true);
  }

  /** Space key should activate the banner action without scrolling the page. */
  onBannerSpace(event: Event): void {
    event.preventDefault();
    this.openApp();
  }
}
